import { z } from 'zod';

export const DataSetPostProcessingScriptContents = z.object({
  contents: z.string(),
});

export type DataSetPostProcessingScriptContents = z.infer<
  typeof DataSetPostProcessingScriptContents
>;
